import { useQuery } from "@apollo/client";
import { GET_UNITS } from "../apollo/queries";
import { getSelectedStoreDetails } from "../utils/helperFunctions";
import useFilters from "../core/hooks/useFilters";

const useUnits = () => {
  const { search, sort, debouncedValue, onChange, onChangeSort, pagination, handlePageChange } =
    useFilters();
  const { loading, error, data, refetch } = useQuery(GET_UNITS, {
    variables: {
      input: {
        limit: pagination.limit,
        pageStart: pagination.pageStart,
        store_id: getSelectedStoreDetails("id"),
        name: debouncedValue,
        sort: sort?.value
      },
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Error While Getting Brands", error);
  }

  return {
    values: {
      allUnit: data?.allUnit || [], // Assuming the API returns an items array
      total: data?.allUnit?.total || 0, // Assuming the API returns a total count
      loading,
      search,
      sort,
      pageValues: {
        current: pagination.pageStart + 1,
        pageSize: pagination.limit,
        total: data?.allUnit?.total || 0,
      },
    },
    functions: {
      onChange,
      refetch,
      onChangeSort,
      handlePageChange,
    },
  };
};

export default useUnits;
